import actionCreatorFactory from "typescript-fsa"

const actionCreator = actionCreatorFactory()
// Reduxの車検証情報state更新アクション
export const qrActions = {
  updateVehicleType: actionCreator<string>("ACTIONS_UPDATE_VEHICLE_TYPE"),
  updateCarModel: actionCreator<string>("ACTIONS_UPDATE_CAR_MODEL"),
  updateFirstInspectionYear: actionCreator<string>("ACTIONS_UPDATE_FIRST_INSPCION_YEAR"),
  updateFirstInspectionMonth: actionCreator<string>("ACTIONS_UPDATE_FIRST_INSPCION_MONTH"),
  updateFirstInspectionDate: actionCreator<string>("ACTIONS_UPDATE_FIRST_INSPCION_DATE"),
  updateCarName: actionCreator<string>("ACTIONS_UPDATE_CAR_NAME"),
  updateAutomaticBraking: actionCreator<string>("ACTIONS_UPDATE_AUTOMATIC_BRAKING"),
  updateAebButtonSelected: actionCreator<string>("ACTIONS_UPDATE_AEB_BUTTON_SELECTED"),
  updateIsScan: actionCreator<boolean>("ACTIONS_UPDATE_IS_SCAN"),
  updateIsAEBShown: actionCreator<boolean>("ACTIONS_UPDATE_IS_AEB_SHOWN"),
  reset: actionCreator("ACTIONS_QR_RESET")
}

export default qrActions
